import { useCallback, useEffect, useRef } from 'react';

// USE TO HANDLE TIMEOUT FUNCTIONS
const useTimeout = (callback, delay) => {
    const callbackRef = useRef(callback);
    const timeoutRef = useRef();

    useEffect(()=>{
        callbackRef.current = callback;
    }, [callback]);

    const set = useCallback(()=>{
        timeoutRef.current = setTimeout(()=> callbackRef.current(), delay);
    }, [delay]);

    const clear = useCallback(()=>{
        timeoutRef.current && clearTimeout(timeoutRef.current);
    // eslint-disable-next-line
    }, [delay]);

    useEffect(()=>{
        set();
        return clear;
    // eslint-disable-next-line    
    }, [delay, set, clear]);

    const reset = useCallback(()=>{
        clear();
        set();
    }, [clear, set]);

    return { reset, clear };
};

export default useTimeout;